import AccountCircle from '@mui/icons-material/AccountCircle'
import AddIcon from '@mui/icons-material/Add'
import BusinessIcon from '@mui/icons-material/Business'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import FlightIcon from '@mui/icons-material/Flight'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import RemoveIcon from '@mui/icons-material/Remove'
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import {Avatar, Badge, Box, Button, Menu, MenuItem, Slide, Typography, useMediaQuery, useTheme} from '@mui/material'
import Chevron from 'assets/images/normal_chevron-booking.svg'
import Chevron1 from 'assets/images/selected_chevron-booking.svg'
import {cpsUrl} from 'config/base'
import {getSmallLogoByCarrier} from 'config/logo.constant'
import {ENDPOINT} from 'config/path'
import {resetLoginState} from 'features/Login/login.slice'
import {get as _get} from 'lodash'
import React, {Fragment, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
    // useLocation,
    useNavigate
} from 'react-router-dom'
import {resetCommonState} from 'redux/common.slice'
import {type AppDispatch, type RootState} from 'redux/store'
import {UpdateLogout, sessionRefreshListener} from 'services/login.service'
import {clearLocalStorageValues} from 'shared/Logout'
import {getTodayDate} from 'utils/helperFunctions'
// import {validateToken} from 'Routes/routes.utils'

interface IUserDetail {
    firstName: string
    lastName: string
    branchStationCode: string
    localStationCode: string
    branchID: number
    isBranchUser: boolean
    isBranchAdmin: boolean
    isCarrierUser: boolean
    carrierCode: string
    isSecondLevelCarrierAdmin: boolean
    isServiceAdmin: boolean
    isServiceUser: boolean
    isCarrierAdmin: boolean
}

const ProfileCard = () => {
    // const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const login = useSelector((state: RootState) => state.login)
    const smallLogos = useSelector((state: RootState) => state.login.smallLogos)
    const administrationMenu = useSelector((state: RootState) => state.login.administrationMenu ?? [])
    const [toggle, setToggle] = useState<boolean>(false)
    const userDetails: IUserDetail = useSelector(
        (state: RootState) =>
            state.login.loginDetails?.securityParams || {
                firstName: '',
                lastName: '',
                branchStationCode: '',
                localStationCode: '',
                isBranchUser: false,
                isBranchAdmin: false,
                isCarrierUser: false,
                carrierCode: '',
                isSecondLevelCarrierAdmin: false,
                isServiceAdmin: false,
                isServiceUser: false
            }
    )

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const isMenuOpen = Boolean(anchorEl)
    const [isHovered, setIsHovered] = useState(false)

    const theme = useTheme()
    const belowMd = useMediaQuery(theme.breakpoints.down('md'))

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
        window.scrollTo(0, 0)
    }

    const handleMouseEnter = () => {
        setIsHovered(true)
    }

    const handleMouseLeave = () => {
        setIsHovered(false)
    }

    const stringAvatar = (name: string) => {
        if (typeof name !== 'undefined' && name !== ' ') {
            return {
                children: `${name.split(' ')[0][0].toUpperCase()}${name.split(' ')[1][0].toUpperCase()}`
            }
        } else {
            return {
                children: ''
            }
        }
    }

    const capitalizeWords = (str: string) =>
        str
            .toLowerCase()
            .split(' ')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')

    const navigatePage = (url: string) => {
        if (url.includes('.jsp')) {
            window.location.href = `${cpsUrl}` + url
        } else if (url.includes('/inviteUser')) {
            // window.location.href = `${cpsUrl}/cpsreact${url}?branchId=${
            //     userDetails.branchID
            // }&date=${getTodayDate()}&registerby=admin`
            window.location.href = `${cpsUrl}${ENDPOINT.inviteUser}?branchId=${
                userDetails.branchID
            }&date=${getTodayDate()}&registerby=admin`
        } else {
            navigate(url)
        }
    }

    const isSubMenusPresent = (menuItem: object): boolean => _get(menuItem, 'subMenus', []).length > 0

    const handleLogout = async () => {
        await sessionRefreshListener(true)
            .then((response) => {
                if (response.status === 202 || response.status === 200) {
                    const payloadLogout = {
                        newLogin: true,
                        logout: true,
                        userId: login.loginDetails.securityParams.userID
                    }

                    void UpdateLogout(payloadLogout)
                    void dispatch(resetLoginState(_get(login, 'authToken.data.refresh_token', '')))
                    dispatch(resetCommonState())
                    clearLocalStorageValues()
                    localStorage.setItem('isLoggedIn', 'false')
                    if (localStorage.getItem('NewLogin') === 'true') {
                        // window.location.href = `${cpsUrl}${ENDPOINT.basePath}${ENDPOINT.login}`
                        navigate(ENDPOINT.logout)
                    } else {
                        window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    const MAP_ICON = {
        accountIcon: <AccountCircle />,
        businessIcon: <BusinessIcon />,
        supervisorIcon: <SupervisorAccountIcon />,
        personAddIcon: <PersonAddIcon />,
        flightIcon: <FlightIcon />
    }

    const getToolsSubMenuIcon = () => {
        if (toggle) {
            return <RemoveIcon />
        } else {
            return <AddIcon />
        }
    }

    const renderMenu = (
        <Menu
            id='accountMenu'
            anchorEl={anchorEl}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            keepMounted
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
            open={isMenuOpen}
            onClose={handleMenuClose}
            sx={{zIndex: theme.zIndex.modal + 1}}
        >
            <MenuItem className='profileNameRectangle' disableRipple disableTouchRipple>
                {userDetails.firstName !== '' && (
                    <Badge>
                        {userDetails.isCarrierUser ? (
                            <Avatar src={getSmallLogoByCarrier(smallLogos, userDetails?.carrierCode)} />
                        ) : (
                            <Avatar
                                className='childAvatar'
                                {...stringAvatar(userDetails.firstName.trim() + ' ' + userDetails.lastName.trim())}
                            />
                        )}
                        <div className='profileCardNameContainer'>
                            <h4 className='profileCardName'>
                                {capitalizeWords(userDetails.firstName.trim() + ' ' + userDetails.lastName.trim())}
                            </h4>
                            <p className='profileCardStation'>
                                <LocationOnIcon className='profileCardStationIcon' />
                                &nbsp;
                                {userDetails.branchStationCode === null
                                    ? userDetails.localStationCode
                                    : userDetails.branchStationCode}
                            </p>
                        </div>
                    </Badge>
                )}
            </MenuItem>
            <Box
                sx={{
                    maxHeight: '279px',
                    display: 'block',
                    overflow: 'auto',
                    borderTop: '1px solid #ced4da',
                    borderBottom: '1px solid #ced4da'
                }}
            >
                <Typography className='dropdown-header'>USER MANAGEMENT</Typography>
                {_get(administrationMenu, 'userManagementMenus', []).map((menuItem: any) => (
                    <MenuItem
                        className='userManagement'
                        key={menuItem.title}
                        onClick={() => navigatePage(menuItem.pathname)}
                    >
                        {MAP_ICON[menuItem.icon]}
                        <Typography>{menuItem.title}</Typography>
                    </MenuItem>
                ))}
                {_get(administrationMenu, 'tools', []).length > 0 && (
                    <Typography className='dropdown-header'>TOOLS</Typography>
                )}
                {_get(administrationMenu, 'tools', []).map((menuItem: any, index: number) => (
                    <Fragment key={`administrationMenu-${index}`}>
                        <MenuItem
                            className='menuToolsLabel'
                            key={menuItem.title}
                            disabled={menuItem.disable}
                            onClick={() => {
                                if (!isSubMenusPresent(menuItem)) {
                                    navigatePage(menuItem.pathname)
                                } else {
                                    setToggle((obj: boolean) => !obj)
                                }
                            }}
                        >
                            <Typography className='w-100 flex-space-between'>
                                {menuItem.title}
                                {isSubMenusPresent(menuItem) && getToolsSubMenuIcon()}
                            </Typography>
                        </MenuItem>
                        <div className={`toolSubMenuContainer ${toggle ? 'show' : 'display-hidden'}`}>
                            {_get(menuItem, 'subMenus', []).map((subMenuItem: any) => (
                                <MenuItem
                                    className='menuToolsLabel'
                                    key={subMenuItem.title}
                                    onClick={() => navigatePage(subMenuItem.pathname)}
                                >
                                    <Typography>{subMenuItem.title}</Typography>
                                </MenuItem>
                            ))}
                        </div>
                    </Fragment>
                ))}
            </Box>
            {
                <MenuItem
                    id='logout'
                    onClick={() => {
                        void handleLogout()
                    }}
                    className='exit_to_app-log-out'
                >
                    <ExitToAppIcon className='menuIcons' />
                    <Typography> Log out</Typography>
                </MenuItem>
            }
        </Menu>
    )
    const renderBelowMdMenu = (
        <Box my={1}>
            <Menu
                className='ListDropdownMenu'
                anchorEl={anchorEl}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                keepMounted
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                open={isMenuOpen}
                onClose={handleMenuClose}
                sx={{
                    zIndex: theme.zIndex.modal + 1,
                    top: '82px',
                    '& .MuiBackdrop-root': {
                        top: '82px'
                    }
                }}
                slotProps={{paper: {className: 'paper'}}}
            >
                <Slide
                    direction='left'
                    in={isMenuOpen}
                    mountOnEnter
                    unmountOnExit
                    timeout={{enter: 700, exit: 100}}
                    easing='cubic-bezier(0.22, 1, 0.36, 1)'
                >
                    <Box>
                        <Button
                            variant='text'
                            onClick={handleMenuClose}
                            className='subMenuBtn'
                            sx={{
                                color: 'black',
                                width: '100%',
                                placeContent: 'flex-start',
                                paddingLeft: '15px'
                            }}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                        >
                            <img src={isHovered ? Chevron1 : Chevron} className='leftExpandMore' alt='ExpandMoreIcon' />
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    textTransform: 'capitalize',
                                    paddingLeft: '5px',
                                    '&:hover': {
                                        color: '#356eab',
                                        backgroundColor: '#ffffff'
                                    }
                                }}
                            >
                                Main Menu
                            </Typography>
                        </Button>
                        <br />
                        <Box sx={{bgcolor: 'rgb(249, 252, 254)'}} className='ham-HelpMenu'>
                            <Typography sx={{fontSize: '16px', fontWeight: '500', padding: '8px'}}>
                                <span>Administration</span>
                            </Typography>
                            <br />
                            <Typography className='help-header'>
                                <span>USER MANAGEMENT</span>
                            </Typography>
                            {_get(administrationMenu, 'userManagementMenus', []).map((menuItem: any) => (
                                <MenuItem
                                    className='help-content'
                                    key={menuItem.title}
                                    onClick={() => navigatePage(menuItem.pathname)}
                                >
                                    {MAP_ICON[menuItem.icon]}
                                    <Typography>{menuItem.title}</Typography>
                                </MenuItem>
                            ))}
                            {_get(administrationMenu, 'tools', []).length > 0 && (
                                <Typography className='help-header'>TOOLS</Typography>
                            )}
                            {_get(administrationMenu, 'tools', []).map((menuItem: any, index: number) => (
                                <Fragment key={`administrationMenu-${index}`}>
                                    <MenuItem
                                        className='help-content'
                                        key={menuItem.title}
                                        disabled={menuItem.disable}
                                        onClick={() => {
                                            if (!isSubMenusPresent(menuItem)) {
                                                navigatePage(menuItem.pathname)
                                            } else {
                                                setToggle((obj: boolean) => !obj)
                                            }
                                        }}
                                    >
                                        <Typography className='w-100 flex-space-between'>
                                            {menuItem.title}
                                            {isSubMenusPresent(menuItem) && getToolsSubMenuIcon()}
                                        </Typography>
                                    </MenuItem>
                                    <div className={`toolSubMenuContainer ${toggle ? 'show' : 'display-hidden'}`}>
                                        {_get(menuItem, 'subMenus', []).map((subMenuItem: any) => (
                                            <MenuItem
                                                className='help-content'
                                                key={subMenuItem.title}
                                                onClick={() => navigatePage(subMenuItem.pathname)}
                                            >
                                                <Typography>{subMenuItem.title}</Typography>
                                            </MenuItem>
                                        ))}
                                    </div>
                                </Fragment>
                            ))}
                        </Box>
                    </Box>
                </Slide>
            </Menu>
        </Box>
    )

    if (!belowMd) {
        return (
            <Box
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        setAnchorEl(event.currentTarget)
                    }
                }}
                className='profileContainer'
            >
                <Badge onClick={handleProfileMenuOpen}>
                    <Avatar
                        className='mainProfileAvatar'
                        {...stringAvatar(userDetails.firstName.trim() + ' ' + userDetails.lastName.trim())}
                    />
                </Badge>
                {renderMenu}
            </Box>
        )
    } else {
        return (
            <Box
                tabIndex={0}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        setAnchorEl(event.currentTarget)
                    }
                }}
                sx={{
                    zIndex: theme.zIndex.modal + 1,
                    bgcolor: 'rgb(249, 252, 254)',
                    '& .MuiBox-root': {
                        margin: '0px'
                    }
                }}
                className='hamHelpWrapper'
            >
                <Box
                    className='hamHelpTitle'
                    onClick={handleProfileMenuOpen}
                    sx={{
                        zIndex: theme.zIndex.modal + 1,
                        fontWeight: '500',
                        fontSize: '16px',
                        color: '#2C2C2C',
                        px: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        fontFamily: '"Roboto-Medium", "Roboto Medium", "Roboto", sans-serif',
                        textAlign: 'left',
                        lineHeight: 'normal',
                        letterSpacing: '0.6px',
                        height: '65px',
                        '&:hover': {boxSizing: 'border-box', color: '#356eab', cursor: 'pointer'},
                        width: 'auto',
                        placeContent: 'flex-start',
                        paddingLeft: '20px'
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <SettingsRoundedIcon fontSize='small' />
                    &nbsp; Administration
                    <Box id='ExpandIcon'>
                        <img src={isHovered ? Chevron1 : Chevron} className='listExpandMore' alt='ExpandMoreIcon' />
                    </Box>
                </Box>
                {renderBelowMdMenu}
            </Box>
        )
    }
}

export default ProfileCard
